import gql from 'graphql-tag';
const SIGNOUT = gql`
  mutation signOut {
    signOut @client
  }
`;

export default SIGNOUT;
